/**
 * TanStack Query hooks for `agency-dashboard`. Thin wrappers over ./api.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	agencyDashboardQueryKeys,
	fetchAgencySummary,
	type AgencySummary,
	type RangeKey,
} from "./api";

/** Rolled-up KPIs + per-client breakdown across the agency's sub-tenants. */
export function useAgencySummary(
	range: RangeKey,
): UseQueryResult<AgencySummary, Error> {
	return useQuery({
		queryKey: agencyDashboardQueryKeys.summary(range),
		queryFn: () => fetchAgencySummary(range),
	});
}
